<template>
  <b-modal
    v-model="showModal"
    ref="modalSelectConfirmUser"
    centered
    @hidden="hide"
    :hide-footer="hideFooter"
  >
    <template #modal-header>ยืนยันโดย</template>
    <HeaderPanel
      title="ยืนยันโดย"
      :filter="filter"
      placeholder="ค้นหา"
      :hasDropdown="false"
      :hasFilter="false"
      @search="handleSearch"
    />

    <div class="body">
      <b-table
        striped
        hover
        responsive
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
        class="mt-2"
      >
        <template v-slot:cell(endDate)="data">
          <div>
            {{
              data.item.endDate
                ? $moment(data.item.endDate).format("DD/MM/YYYY")
                : "-"
            }}
          </div>
        </template>

        <template v-slot:cell(enabled)="{ item }">
          <div
            :class="`${
              item.enabled ? 'tw-text-green-500' : 'tw-text-red-500'
            } `"
          >
            {{ item.enabled ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
          </div>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(action)="data">
          <b-button
            :disabled="checkListSelectCustomer(data.item.userId)"
            class="submit-btn w-80px"
            @click.prevent="submit(data.item)"
          >
            {{
              checkListSelectCustomer(data.item.userId) ? "เลือกแล้ว" : "เลือก"
            }}
          </b-button>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :pageOptions="pageOptions"
        :rows="rows"
        :filter="filter"
        @pagination="pagination"
      />
    </div>

    <template #modal-footer>
      <b-row>
        <b-col class="text-left">
          <b-button @click.prevent="hide(1)" class="border-btn"
            >ยกเลิก</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="showSaveBtn">
        <b-col>
          <b-button class="submit-btn" @click.prevent="submit">บันทึก</b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
export default {
  components: {},
  props: {
    hideFooter: {
      required: false,
      default: false,
      type: Boolean,
    },
    selectedCustomer: {
      required: false,
    },
    showSaveBtn: {
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
      fields: [
        {
          key: "action",
          label: "ดำเนินการ",
          class: "w-50px text-nowrap",
        },
        {
          key: "displayName",
          label: "ชื่อ",
          class: "w-100px text-nowrap",
        },
      ],
      items: [],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      filter: {
        search: "",
        adminRoleId: [],
        skip: 1,
        take: 10,
        page: 1,
      },
    };
  },
  watch: {},
  methods: {
    checkListSelectCustomer(userId) {
      return this.selectedCustomer?.userId === userId;
    },
    async show() {
      this.getList();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    getList: async function () {
      this.isBusy = true;

      const getData = await this.$services.admin.searchUserAdmin({
        ...this.filter,
        search: undefined,
        page: undefined,
        skip: this.filter.page,
        name: this.filter.search,
      });

      if (getData.result == 1) {
        this.items = getData.detail.data;
        this.rows = getData.detail.count;
      }

      this.isBusy = false;
    },
    handleSearch(e) {
      this.filter = {
        ...this.filter,
        ...e,
      };
      this.getList();
    },

    submit(item) {
      this.$emit("select", item);
      this.hide();
    },

    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getList();
    },
    pagination(page) {
      this.filter.page = page;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-table {
  padding: 15px;
  .header {
    text-align: right;
    margin: 10px 0px;

    .btn-export {
      width: 100px;
      background: white;
      color: black;
    }
  }

  .footer-modal {
    text-align: right;
    margin-top: 10px;
  }
}

::v-deep .modal-dialog {
  max-width: 800px;
}

::v-deep .modal-footer {
  justify-content: space-between;
}
.btn-save {
  color: #fff;
  background-color: var(--primary-color);
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}
.btn-cancel {
  color: #fff;
  background-color: #39424e;
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}

.w-80px {
  width: 80px;
}
</style>
